import { React, useEffect, useState } from "react";
import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
    PDFViewer,
    Font,
    Canvas,
    Link
} from "@react-pdf/renderer";
import sunrise from "../../utils/sunriseLogo2.png";
import notAllowedSymbol from "../../utils/ic_no_image_found.png";

import FigtreeRegular from "../../fonts/static/Figtree-Regular.ttf";
import FigtreeBold from "../../fonts/static/Figtree-Bold.ttf";
import { ToWords } from 'to-words';

import eiaci_logo from "../../utils/eiaci_logo.jpeg";
import qrs_logo from "../../utils/qrs_logo.png";
import iaf_logo from "../../utils/iaf_logo.png";
import ic_logo from "../../utils/ic_logo.png";


// import FigtreeRegular from "/";

// import pro1 from "../utils/product1.PNG";
// import pro2 from "../utils/product2.PNG";
// import pro3 from "../utils/product3.PNG";



// Font.register({
//     family: "Figtree",
//     src: FigtreeRegular,
//     format: "truetype",
// });


const toWords = new ToWords({
    localeCode: 'en-AE'
});

//Register additional font weights (optional)
Font.register({
    family: "Figtree",
    format: 'truetype',
    fonts: [
        { src: FigtreeRegular, fontWeight: "normal" },
        { src: FigtreeBold, fontWeight: "bold" },
    ],
});




const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 10,
        fontFamily: "Figtree",
        paddingBottom: 180,
        paddingTop: 10,
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 10,
        borderBottomWidth: 1
    },
    headerText: { fontSize: 12, fontWeight: "bold" },
    quotationTitleText: { fontSize: 12, fontWeight: "bold", paddingBottom: 10 },
    projectTitleText: { fontSize: 12, fontWeight: "bold", paddingBottom: 4, paddingTop: 6 },
    logo: { width: 110, height: 80 },
    prodImage: { width: 40, height: 40 },
    prodImage_No_image: { width: 20, height: 20 },
    sectionAbove: { marginTop: 4 },
    section: { marginBottom: 10, paddingTop: 10 },
    paddingBottom: { paddingBottom: 10 },
    seperator: { borderTopWidth: 1 },
    tableContainer: {
        flexDirection: "column",
        minHeight: "100", // Adjust this value based on your needs
        // maxHeight: 'auto', // Adjust this value based on your needs
        overflow: "hidden",
    },
    table: {
        marginTop: 10,
        width: "100%",
        borderLeftWidth: 0.5,
        borderTopWidth: 0.5,
        borderLeftColor: "#000000",
        borderTopColor: "#000000",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },
    tableRow: {
        flexDirection: "row",
    },
    tableRowBody: {
        flexDirection: "row",
    },
    tableHeader: {
        backgroundColor: "#cfcfd1",

    },


    tableCellValueInTablehead: {
        flex: 1.6,
        padding: 5,
        textAlign: "center",
        borderBottomWidth: 0.5,
        borderBottomColor: "#000000"
    },

    tableCell: {
        flex: 1,
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },
    tableCell_SN: {
        flex: 0.5,
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },

    tableCellReftypeHeading: {
        flex: 1.4,
        paddingVertical: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },
    tableCellReftype: {
        flex: 1.4,
        paddingVertical: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1"
    },
    tableCellBody: {
        flex: 1,
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1"
    },
    tableCellBody_SN: {
        flex: 0.5,
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1"
    },
    tableCellBodyAmount: {
        flex: 1.6,
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1"
    },
    tableCellProductImage: {
        flex: 2, // Increased flex value for more width
        paddingTop: 5,
        paddingHorizontal: 2,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },
    tableCellProductImageBody: {
        flex: 2, // Increased flex value for more width
        paddingTop: 5,
        paddingHorizontal: 2,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1"
    },
    tableCellArticle: {
        flex: 1.9, // Increased flex value for more width
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },

    tableCellArticleBody: {
        flex: 1.9,
        padding: 5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1",
        overflowWrap: "break-word",
        hyphens: "manual"
    },

    tableWideCellHeading: {
        flex: 5,
        padding: 5,
        textAlign: "center",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#000000",
        borderBottomColor: "#000000"
    },


    tableWideCellView: {
        flex: 5,
        padding: 5,
        flexDirection: "column",
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRightColor: "#cfcfd1",
        borderBottomColor: "#cfcfd1"
    },

    tableWideCell: {
        flex: 3,
        padding: 5,
        textAlign: "left"
    },
    summary: {
        textAlign: "right",
    },
    footer: { marginTop: 20, fontSize: 10, borderTopWidth: 1, paddingTop: 5 },
    pageNumber: {
        position: "absolute",
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: "center",
        fontSize: 10,
    },
    descriptionText: {
        fontSize: 9
    },
    watermarkText: {
        color: "#00000040",
        fontSize: 50,
        zIndex: 100
    }

});



const manipulateTextToMakenewLine = (stringReceived) => {

    let n = 10; // insert a character after every 5 characters
    let insertChar = "\n";
    let outputString = stringReceived?.split("").reduce(function (acc, val, i) {
        return i % n === 0 && i !== 0 ? acc + insertChar + val : acc + val;
    }, "");

    return (outputString)


}


const splitText = (stringReceived) => {

    console.log("stringReceived ", stringReceived)

    let n = 10; // insert a character after every 5 characters
    let insertChar = "\n";
    let outputString = stringReceived.split(",")

    return (outputString)

}

const arrangeSalesPersonNameArray = (arrayToBeOrdered) => {


    console.log("arrayToBeOrdered ", arrayToBeOrdered)

    let newArray = arrayToBeOrdered.map((textToBeEdited) => {

        if (textToBeEdited.includes("@")) {

            return "Email : " + textToBeEdited

        } else if (!isNaN(textToBeEdited.replace(/\s/g, ""))) {
            return "Mob : " + textToBeEdited
        } else {
            return textToBeEdited
        }

    })

    let mobObject = newArray.filter((itemFilter) => {
        return itemFilter.includes("Mob")
    })

    let emailObject = newArray.filter((itemFilter) => {
        return itemFilter.includes("@")
    })


    let nameObject = newArray.filter((itemFilter) => {
        return !itemFilter.includes("@") && !itemFilter.includes("Mob")
    })

    console.log("arrayToBeOrdered newArray mobObject", newArray, mobObject, emailObject)

    return [nameObject, mobObject, emailObject]


}




const QuotationPDF_2 = ({
    selectedLead,
    formattedDate,
    leadProducts,
    productsInQuotationFromAPI,
    vatValue,
    alreadySentQuotationNumber,
    discountValue,
    salesOrderYesOrNo
}) => {


    const [isVatpresent, setIsVatpresent] = useState(null)


    const [netValueState, setNetValueState] = useState(null)

    useEffect(() => {

        console.log("Quotation pdf values vatValue ", vatValue, discountValue)

        if (productsInQuotationFromAPI) {
            if (vatValue > 0) {
                console.log("if vatPresent")
                setIsVatpresent(true)
            } else {
                console.log("else vatPresent")
                setIsVatpresent(false)
            }


            {
                vatValue > 0 ?
                    setNetValueState(
                        productsInQuotationFromAPI?.filter((item) => {
                            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                return false
                            }
                            else {
                                return true
                            }
                        }).reduce((acc, curr) => {
                            return acc + (curr.itemQuantity * curr.itemPrice);
                        }, 0) -
                        (discountValue ? discountValue : 0)

                        +
                        ((
                            productsInQuotationFromAPI?.filter((item) => {
                                if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                    return false
                                }
                                else {
                                    return true
                                }
                            }).reduce((acc, curr) => {
                                return acc + (curr.itemQuantity * curr.itemPrice);
                            }, 0) -
                            (discountValue ? discountValue : 0)
                        )
                        * productsInQuotationFromAPI[0]?.dynamicVatFromAPI)/100
                    )
                    :
                    setNetValueState(
                        productsInQuotationFromAPI?.filter((item) => {
                            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                return false
                            }
                            else {
                                return true
                            }
                        }).reduce((acc, curr) => {
                            return acc + (curr.itemQuantity * curr.itemPrice);
                        }, 0) -
                        (discountValue ? discountValue : 0)
                    )
            }


        }


    }, [productsInQuotationFromAPI])

    console.log('selectedLead in pdf_2: productsInQuotationFromAPI >>', selectedLead, productsInQuotationFromAPI)

    // {
    //  return console.log('selectedLead in pdf:',selectedLead)
    //  return console.log('leadProducts in pdf:',leadProducts)

    const consoleImage = (index, item) => {
        console.log("is base 64>+++", index, item.itemImageBase64, item.itemImageBase64.includes("data:image/"));

    }
    return (
        <Document>
            <Page size="A4" style={styles.page}>

                {
                    (productsInQuotationFromAPI[0]?.area_code === "Draft" || productsInQuotationFromAPI[0]?.area_code === "For Approval")
                    &&
                    <Text style={{ position: "absolute", top: "40%", left: "30%", ...styles.watermarkText }} fixed >
                        Draft Copy
                    </Text>}



                {/* Header */}
                <View style={styles.header} fixed>
                    <View>
                        <Text style={styles.headerText}>SUNRISE OASIS LIGHTING LLC</Text>



                        {
                            (selectedLead.lead_salespersonName || productsInQuotationFromAPI[0].salespersonName) &&
                            <Text style={{ marginTop: 8, fontSize: 10 }}>
                                Contact
                            </Text>
                        }


                        <View style={{ flexDirection: "column", marginTop: 4 }}>
                            {
                                (selectedLead.lead_salespersonName || productsInQuotationFromAPI[0].salespersonName) &&
                                arrangeSalesPersonNameArray(splitText( productsInQuotationFromAPI[0].salespersonName ? productsInQuotationFromAPI[0].salespersonName :selectedLead.lead_salespersonName ?
                                    selectedLead.lead_salespersonName :
                                    ""
                                ))?.map((item) => {
                                    return (
                                        <Text style={{ fontWeight: "bold" }}>{item}</Text>
                                    )
                                })
                            }

                        </View>

                    </View>
                    <Image src={sunrise} style={styles.logo} />
                </View>

                {/* Customer & Project Details */}

                <View style={styles.section}>
                    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                        <View style={{ width: "65%" }}>


                            {
                                salesOrderYesOrNo?.isthisSalesOrder ?
                                    <Text style={styles.quotationTitleText}>Sales Order</Text>
                                    :
                                    <Text style={styles.quotationTitleText}>Quotation</Text>
                            }
                            <Text>To:</Text>

                            <Text>{selectedLead?.lead_organization ? selectedLead?.lead_organization?.toUpperCase() : selectedLead?.accdesc?.toUpperCase()}</Text>

                            <Text>Attn: {  productsInQuotationFromAPI[0].head1 ? productsInQuotationFromAPI[0].head1 :  selectedLead?.lead_primarycontact ? selectedLead?.lead_primarycontact : ""}</Text>
                            <Text>{selectedLead?.lead_organizationAddress}</Text>
                            <Text>

                                {productsInQuotationFromAPI[0].Lead_email ? productsInQuotationFromAPI[0].Lead_email : selectedLead.lead_email ? selectedLead.lead_email : ""} | { productsInQuotationFromAPI[0].Lead_Phone ? productsInQuotationFromAPI[0].Lead_Phone :selectedLead.lead_phone ? selectedLead.lead_phone : ""}
                            </Text>

                        </View>
                        <View style={{ width: "35%" }}>
                            <View style={{ marginTop: "auto", marginRight: "20%" }}>

                                {
                                    salesOrderYesOrNo?.isthisSalesOrder ?
                                        <Text>Ref. No. : {alreadySentQuotationNumber ? alreadySentQuotationNumber : selectedLead?.Salesorder_No}</Text>
                                        :
                                        <Text>Ref. No. : {alreadySentQuotationNumber ? alreadySentQuotationNumber : selectedLead?.Proposal_No ? selectedLead?.Proposal_No : productsInQuotationFromAPI[0]?.quotation_number}</Text>
                                }



                                {
                                    selectedLead.Salesorder_No
                                        ?
                                        null
                                        :

                                        productsInQuotationFromAPI[0]?.revision_number &&
                                        <Text style={styles.sectionAbove}>Rev. No. : {productsInQuotationFromAPI[0]?.revision_number}</Text>
                                }

                                <Text style={styles.sectionAbove}>Date: {formattedDate}</Text>
                            </View>
                            <View style={{ marginTop: "auto", marginRight: "20%" }}>
                                <Text style={styles.projectTitleText}>Project</Text>
                                <Text>{
                                    productsInQuotationFromAPI?.length > 0 ? productsInQuotationFromAPI[0]?.project_name_from_details : ""
                                }</Text>
                            </View>
                        </View>

                    </View>

                </View>

                {/* Products Table */}

                {/* Products Table */}
                <View style={styles.tableContainer}>
                    <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeader]}>
                            <Text style={[styles.tableCell_SN, styles.descriptionText]}>S.N</Text>
                            <Text style={[styles.tableCellReftypeHeading, styles.descriptionText]}>Ref/Type</Text>
                            <Text style={[styles.tableCellArticle, styles.descriptionText]}>Article No</Text>
                            <Text style={[styles.tableWideCellHeading, styles.descriptionText]}>Descriptions</Text>
                            <Text style={[styles.tableCellProductImage, styles.descriptionText]}>Product Image</Text>
                            <Text style={[styles.tableCell, { flex: 0.8 }, styles.descriptionText]}>Unit</Text>
                            <Text style={[styles.tableCell, { flex: 0.6, paddingLeft: 1 }, styles.descriptionText]}>Qty</Text>
                            <Text style={[styles.tableCell, { flex: 1.3 }, styles.descriptionText]}>Unit Price</Text>
                            <Text style={[styles.tableCellValueInTablehead, { flex: 1.3 }, styles.descriptionText]}>Value</Text>
                        </View>
                        {productsInQuotationFromAPI?.map((item, index) => (
                            <View style={styles.tableRowBody} key={index} wrap={false}>
                                <Text style={[styles.tableCellBody_SN, styles.descriptionText]}>{index + 1}</Text>
                                <Text style={[styles.tableCellReftype, styles.descriptionText]}>{item.itemCustRef}</Text>
                                <View style={[styles.tableCellArticleBody, styles.descriptionText]}>
                                    <Text >{manipulateTextToMakenewLine(item.itemCode) || '--'}</Text>
                                </View>

                                <View style={[styles.tableWideCellView, styles.descriptionText]}>
                                    <Text style={styles.descriptionText} >{item.itemDescription}</Text>
                                    <View>
                                        <Link target={"blank"} src={item.itemWebLink} >{item.itemWebLink}</Link>
                                    </View>
                                </View>
                                <Text style={styles.tableCellProductImageBody}>

                                    {
                                        item.itemImageBase64 ?
                                            item.itemImageBase64 === "" ?
                                                <View></View>
                                                :
                                                item.itemImageBase64.includes("data:image/") ?
                                                    <Image src={item.itemImageBase64} style={styles.prodImage} />
                                                    :
                                                    <View></View>
                                            :
                                            <View></View>
                                    }



                                </Text>
                                <Text style={[styles.tableCellBody, { flex: 0.8 }, styles.descriptionText]}>{item.itemUnit || '--'}</Text>
                                <Text style={[styles.tableCellBody, { flex: 0.6, paddingLeft: 1 }, styles.descriptionText]}>{item.itemQuantity || '--'}</Text>
                                <Text style={[styles.tableCellBody, { flex: 1.3 }, styles.descriptionText]}>{item.itemFoc === "FOC" ? "FOC" : parseFloat(item.itemPrice).toFixed(2)}</Text>
                                <Text style={[styles.tableCellBodyAmount, { flex: 1.3 }, styles.descriptionText]}>{item.itemFoc === "FOC" ? "FOC"
                                    :
                                    (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") ?
                                        ""
                                        :
                                        parseFloat(item.itemAmount).toFixed(2)
                                }</Text>
                            </View>
                        ))}
                    </View>
                </View>

                {/* Pricing Summary */}

                <View wrap={false} style={{ flexDirection: "row", justifyContent: "space-between", marginTop: "10px" }}>
                    <View style={{ width: "50%" }}>
                        <Text style={{ marginTop: "auto" }}>Net Value in Words</Text>
                        {netValueState &&
                            <Text>
                                {productsInQuotationFromAPI[0]?.fc + " : "}
                                {

                                    toWords.convert(parseInt(netValueState))
                                }
                                {" "}
                                {
                                    ((netValueState - Math.floor(netValueState)).toFixed(2) * 100) ?
                                        <Text>AND {parseInt((netValueState - Math.floor(netValueState)).toFixed(2) * 100)} / 100 ONLY</Text> :
                                        <Text></Text>

                                }
                            </Text>
                        }

                    </View>
                    <View style={[{ fontWeight: "bold", width: "34%" }]}>

                        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                            <Text >Total Value: </Text>
                            <Text >
                                {productsInQuotationFromAPI?.filter((item) => {
                                    if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                        return false
                                    }
                                    else {
                                        return true
                                    }
                                }).reduce((acc, curr) => {
                                    return acc + (curr.itemQuantity * curr.itemPrice);
                                }, 0).toFixed(2)}
                            </Text>
                        </View>

                        {discountValue &&
                            <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 4 }}>
                                <Text >Special Discount: </Text>
                                <Text >
                                    {discountValue}
                                </Text>
                            </View>
                        }
                         
                        {discountValue &&
                            <View style={{ flexDirection: "row", justifyContent: "space-between" , marginTop: 4}}>

                                <Text >Price After Discount: </Text>
                                <Text>
                                    {parseFloat(

                                        productsInQuotationFromAPI?.filter((item) => {
                                            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                                return false
                                            }
                                            else {
                                                return true
                                            }
                                        }).reduce((acc, curr) => {
                                            return acc + (curr.itemQuantity * curr.itemPrice);
                                        }, 0) -
                                        (discountValue ? discountValue : 0)


                                    ).toFixed(2)}
                                </Text>
                            </View>
                        }

                        <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 4 }}>
                            <Text >VAT {productsInQuotationFromAPI[0]?.dynamicVatFromAPI}%: </Text>
                            <Text >
                                {isVatpresent ?
                                    parseFloat(
                                       ( (
                                            productsInQuotationFromAPI?.filter((item) => {
                                                if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                                    return false
                                                }
                                                else {
                                                    return true
                                                }
                                            }).reduce((acc, curr) => {
                                                return acc + (curr.itemQuantity * curr.itemPrice);
                                            }, 0) -
                                            (discountValue ? discountValue : 0)
                                        )
                                        * productsInQuotationFromAPI[0]?.dynamicVatFromAPI ) /100
                                    ).toFixed(2)
                                    :
                                    0
                                }
                            </Text>
                        </View>



                        <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 4 }}>
                            <Text >Net Value: </Text>
                            <Text >
                                {isVatpresent ?
                                    (
                                        productsInQuotationFromAPI?.filter((item) => {
                                            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                                return false
                                            }
                                            else {
                                                return true
                                            }
                                        }).reduce((acc, curr) => {
                                            return acc + (curr.itemQuantity * curr.itemPrice);
                                        }, 0) -
                                        (discountValue ? discountValue : 0)

                                        +

                                        ((
                                            productsInQuotationFromAPI?.filter((item) => {
                                                if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                                    return false
                                                }
                                                else {
                                                    return true
                                                }
                                            }).reduce((acc, curr) => {
                                                return acc + (curr.itemQuantity * curr.itemPrice);
                                            }, 0) -
                                            (discountValue ? discountValue : 0)
                                        ) * productsInQuotationFromAPI[0]?.dynamicVatFromAPI)/100
                                    ).toFixed(2)
                                    :
                                    (
                                        productsInQuotationFromAPI?.filter((item) => {
                                            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                                                return false
                                            }
                                            else {
                                                return true
                                            }
                                        }).reduce((acc, curr) => {
                                            return acc + (curr.itemQuantity * curr.itemPrice);
                                        }, 0) -
                                        (discountValue ? discountValue : 0)
                                    ).toFixed(2)
                                }
                            </Text>
                        </View>

                    </View>
                </View>



                <View wrap={false}>
                    {/* Terms & Conditions */}
                    <View style={styles.footer}>
                        <Text style={styles.headerText}>Terms & Conditions:</Text>

                        <Text style={{ marginTop: 4 }}>
                            {productsInQuotationFromAPI[0]?.payment}
                        </Text>


                    </View>

                    <View style={[styles.section, { borderTopWidth: 1 }]}>
                        <Text style={styles.headerText}>Prepared by:</Text>
                        {console.log("selectedLead pro array >> prep ", selectedLead, productsInQuotationFromAPI)}

                        {(selectedLead.lead_coordinator != "-" || productsInQuotationFromAPI[0].Coordinator != "-") ?
                            (selectedLead.lead_CoordinatorName || productsInQuotationFromAPI[0].lead_CoordinatorName) &&
                            arrangeSalesPersonNameArray(splitText(selectedLead.lead_CoordinatorName ? selectedLead.lead_CoordinatorName : productsInQuotationFromAPI[0].lead_CoordinatorName))?.map((item) => {
                                return (
                                    <Text>{item}</Text>
                                )
                            })
                            // <Text>1st</Text>

                            :
                            // <Text>2nds</Text>
                            (selectedLead.lead_salespersonName || productsInQuotationFromAPI[0].salespersonName) &&
                            arrangeSalesPersonNameArray(splitText(selectedLead.lead_salespersonName ? selectedLead.lead_salespersonName : productsInQuotationFromAPI[0].salespersonName))?.map((item) => {
                                return (
                                    <Text>{item}</Text>
                                )
                            })
                        }

                    </View>

                </View>


                <View
                    style={styles.pageNumber}
                    fixed>
                    <Text
                        render={({ pageNumber, totalPages }) =>
                            `Page ${pageNumber} of ${totalPages}`
                        }
                    />
                    <View style={{ flexDirection: "row", justifyContent: "space-between", padding: 10, borderBottomWidth: 1 }}>
                        <View style={{ fontSize: 8, color: "#000000" }}>
                            <Text style={{ fontWeight: "bold" }}>
                                Head Office & Showroom 1
                            </Text>
                            <Text>
                                Warehouse No.13,
                            </Text>
                            <Text>
                                Al Kharman Street,
                            </Text>
                            <Text>
                                Al Quoz Industrial Area 4
                            </Text>
                            <Text>
                                Dubai UAE
                            </Text>
                            <Text>04-3236088</Text>

                        </View>
                        <View style={{ fontSize: 8, color: "#000000" }}>
                            <Text style={{ fontWeight: "bold" }}>
                                Showroom 2
                            </Text>
                            <Text>
                                Shop No. 27,
                            </Text>
                            <Text>
                                Al Nakhal Road,
                            </Text>
                            <Text>
                                Deira
                            </Text>
                            <Text>
                                Dubai UAE
                            </Text>
                            <Text>
                                04-3236088
                            </Text>


                        </View>

                        <View style={{ fontSize: 8, color: "#000000" }}>
                            <Text style={{ fontWeight: "bold" }}>
                                Showroom 3
                            </Text>
                            <Text>
                                Shop No.2,
                            </Text>
                            <Text>
                                Mussafah 34
                            </Text>
                            <Text>
                                Near New Labour Court
                            </Text>
                            <Text>
                                Abu Dhabi - UAE
                            </Text>
                            <Text>
                                02-8836637
                            </Text>

                        </View>

                        <View style={{ fontSize: 8, color: "#000000" }}>
                            <Text style={{ fontWeight: "bold" }}>
                                Showroom 4
                            </Text>
                            <Text>
                                Al Mutanabbi
                            </Text>
                            <Text>
                                Al Malaz,
                            </Text>
                            <Text>
                                Riyadh-12831
                            </Text>
                            <Text>
                                KSA
                            </Text>
                            <Text>
                                11-2253565
                            </Text>


                        </View>

                    </View>
                    <View style={{ flexDirection: "row", justifyContent: "space-around", alignItems: "center", marginTop: 4 }}>
                        <Text style={{ color: "#305CDE" }}>info@sunriseoasislighting.com </Text>
                        <View style={{ flexDirection: "row", alignItems: "center" }}>
                            <Image style={{ height: 20, marginRight: 10, marginTop: 4 }} src={eiaci_logo} />
                            <Image style={{ height: 20, marginRight: 10 }} src={qrs_logo} />
                            <Image style={{ height: 25, marginRight: 10 }} src={iaf_logo} />
                            <Image style={{ height: 25 }} src={ic_logo} />
                        </View>
                        <Text style={{ color: "#305CDE" }}>www.sunriseoasislighting.com</Text>
                    </View>




                </View>


            </Page>


        </Document >
    );

};

export default QuotationPDF_2;
